<template>
    <div class="">
        <div class="custom-loader-wrapper" v-if="loader">
            <div class="text-center">
                <span class="d-block max-450">We are processing your download and this may take some time. Do not close
                    this window until the download begins.</span>
                <img v-bind:src="$api_url + '/images/download-loader.svg'" class="loader-logo" width="100px" />
                <p class="mt-5">Plesae click <a target="_blank" :href="$api_url + '/company/dashboard'">here</a> or below
                    if you want to continue surfing the system.</p>
                <b-button class="mb-1" target="_blank" :href="$api_url + '/company/dashboard'">Dashboard</b-button>

            </div>
        </div>
        <div class="row mt-4 no-margin">
            <div class="ibox col-md-12">
                <div class="ibox-title dashboard_title px-0">
                    <h4 class="font-regular with-blue-text">Current Selected: <span v-if="new_law == 'yes'">Schedule C /
                            তফসিল গ</span><span v-else>Monthly statement of tax deducted at source</span></h4>
                </div>
                <div class="ibox-content px-0 trz_ppl_wrapper_2 mt-3">
                    <div class="d-inline-block form-group" style="max-width: 200px;">
                        <label>Select Fiscal Year</label>
                        <b-form-select v-model="fiscal_year">
                            <b-form-select-option value="">Select Fiscal Year</b-form-select-option>
                            <b-form-select-option v-for="(data, n) in received_report_info" :key="n"
                                :value="data.fiscal_year">{{ data.fiscal_year }}</b-form-select-option>
                        </b-form-select>
                    </div>
                    <div class="d-inline-block trz_fields trz-custom-dropdown mb-1">
                        <b-dropdown id="dropdown-fields" text="Select Additional Fields" ref="dropdown"
                            class="mb-1 position-relative">
                            <b-dropdown-form>
                                <b-form-group @submit.stop.prevent>
                                    <div class="form-group">
                                        <b-form-checkbox-group v-model="column_selected" :options="column_options"
                                            switches />
                                    </div>
                                    <button type="button" @click="setcolumn()"
                                        class="btn btn-primary d-none">Save</button>
                                </b-form-group>
                            </b-dropdown-form>
                        </b-dropdown>
                    </div>
                    {{ clickSelect }}
                    <!-- alpha fix- removed class ml-2 from below div -->
                    <div class="d-inline-block report-selected-columns" v-if="column_selected_view.length > 0">
                        <span class="font-semi-bold text-secondary py-1 px-2 bg-white rounded"
                            v-for="column in column_selected_view">{{ stringView(column) }}</span></div>
                </div>
            </div>
            <template v-if="new_law == 'yes'">
                <table v-for="(data, n) in received_report_info" v-if="data.fiscal_year == fiscal_year"
                    class="table 108_return" :key="n">
                    <thead>
                        <tr class="table-head">
                            <th scope="col">Month - Fiscal Year</th>
                            <th scope="col">Download (English)</th>
                            <th scope="col">Download (Bangla)</th>
                            <th scope="col">Upload Receipt</th>
                            <th scope="col">Download Receipt</th>
                            <th scope="col">Submission Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr style="display: none;"></tr>
                        <tr class="table-row hover-bg" v-for="(month, n) in sortArrays(data.month)"
                            v-if="month.status == 'approved'" :key="n">
                            <td>{{ month.name }} - {{ year_from_fiscal_year_month_val(month.value, fiscal_year) }}</td>
                            <td><a @click="getReportNewFormate(fiscal_year, month.value, 'en')" class="cursor-pointer"
                                    v-if="$acl['regulatory/filing/download'] == 2"><img
                                        v-bind:src="$api_url + '/images/excel-icon.png'" class="mr-2"
                                        width="20px" />Download</a></td>
                            <td><a @click="getReportNewFormate(fiscal_year, month.value, 'bn')" class="cursor-pointer"
                                    v-if="$acl['regulatory/filing/download'] == 2"><img
                                        v-bind:src="$api_url + '/images/excel-icon.png'" class="mr-2"
                                        width="20px" />Download</a></td>
                            <td><a href="#" @click="showUpload(month.value)"
                                    v-if="$acl['regulatory/filing/upload'] == 2"><b-icon icon="upload"
                                        class="mr-2"></b-icon>Upload</a></td>
                            <td><a v-if="month.received_copy_statement_of_deduct == 'yes' && $acl['regulatory/filing/download'] == 2"
                                    :href="$api_url + '/payroll_report_return_statement_of_deduct?received_report=received_download&year=' + fiscal_year + '&month=' + month.value + '&dataflg=1'"><b-icon
                                        icon="download" class="mr-2"></b-icon>Download</a><a v-else>N/A</a></td>
                            <td>{{ month.file_date_sod || compliance_placeholder }}</td>
                        </tr>
                    </tbody>
                </table>
            </template>
            <template v-else>
                <table v-for="(data, n) in received_report_info" v-if="data.fiscal_year == fiscal_year"
                    class="table 108_return" :key="n">
                    <thead>
                        <tr class="table-head">
                            <th scope="col">Month - Fiscal Year</th>
                            <th scope="col">View Details</th>
                            <th scope="col">Download Excel</th>
                            <th scope="col">Upload Receipt</th>
                            <th scope="col">Download Receipt</th>
                            <th scope="col">Submission Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr style="display: none;"></tr>
                        <tr class="table-row hover-bg" v-for="(month, n) in sortArrays(data.month)"
                            v-if="month.status == 'approved'" :key="n">
                            <td>{{ month.name }} - {{ year_from_fiscal_year_month_val(month.value, fiscal_year) }}</td>
                            <td><a href="#" @click="statementOfDeductData(month.value, fiscal_year)"
                                    v-if="$acl['regulatory/filing/view/details'] == 2">View Details</a></td>
                            <td><a @click="getReport(fiscal_year, month.value)" class="cursor-pointer"
                                    v-if="$acl['regulatory/filing/download'] == 2"><img
                                        v-bind:src="$api_url + '/images/excel-icon.png'" class="mr-2"
                                        width="20px" />Download</a></td>
                            <td><a href="#" @click="showUpload(month.value)"
                                    v-if="$acl['regulatory/filing/upload'] == 2"><b-icon icon="upload"
                                        class="mr-2"></b-icon>Upload</a></td>
                            <td><a v-if="month.received_copy_statement_of_deduct == 'yes' && $acl['regulatory/filing/download'] == 2"
                                    :href="$api_url + '/payroll_report_return_statement_of_deduct?received_report=received_download&year=' + fiscal_year + '&month=' + month.value + '&dataflg=1'"><b-icon
                                        icon="download" class="mr-2"></b-icon>Download</a><a v-else>N/A</a></td>
                            <td>{{ month.file_date_sod || compliance_placeholder }}</td>
                        </tr>
                    </tbody>
                </table>
            </template>

        </div>





        <b-modal id="satement-tax-deduction" dialog-class="modal-xxl" size="xl" scrollable hide-footer title="Details">
            <div class="clearfix row py-2 mb-2">
                <div class="col-sm-6 px-3 company-form-box-title">{{ d_month }} - {{ d_year }}</div>
            </div>

            <table class="table ">
                <thead class="" style="">
                    <tr class="table-head" v-for="(detail, index) in paginatedData" :key="detail.employee_ID">
                        <template v-if="index < 1">
                            <td class="text-center" v-for="(v, i, count) in detail"><template
                                    v-if="i == 'gross_pay'">Total Earnings</template><template
                                    v-else-if="i == 'employee_etin'">e-TIN</template><template v-else>{{
                                    replaceTableHeads(i) }}</template></td>
                        </template>
                    </tr>
                </thead>
                <tbody>
                    <tr style="display: none;"></tr>
                    <tr class="table-row hover-bg " v-for="detail in paginatedData" :key="detail.employee_ID">
                        <!--aboni 10-11-21-->
                        <template v-for="(v, i, count) in detail">
                            <td
                                v-if="column_selected.indexOf(stringViewReverse(i)) !== -1 || column_selected.indexOf(i) !== -1">
                                {{ v }}</td>
                            <td
                                v-else-if="i == 'Name Of Employee' || i == 'Job Position' || i == 'details' || i == 'SL._No.'">
                                {{ v }}</td>
                            <td v-else class="text-right">{{ v }}</td>

                        </template>
                        <!--aboni 10-11-21-->
                    </tr>
                </tbody>
            </table>

            <div v-if="paginatedData.length == 0" class="px-3 py-3 no-result-cell text-center">
                <span class="d-block text-center">{{ empty_result }}</span>
                <img v-bind:src="$api_url + '/images/download-loader.svg'" class="loader-logo" width="100px" />
            </div>
            <div v-else class="px-3">
                <div class="row py-2 no-margin" v-if="paginatedData.length > 0">
                    <div class="col-md-12 p-0 no-margin" v-if="paginatedData.length > 0">

                        <b-pagination-nav class="float-right mt-1" v-model="pagination.currentPage"
                            :number-of-pages="pagination.pages" prev-text="Previous" next-text="Next" base-url="#"
                            first-number last-number></b-pagination-nav>

                    </div>

                </div>
            </div>
        </b-modal>

        <b-modal id="satement-tax-deduction-upload-excell" size="lg" centered hide-footer title="Upload Receipt File"
            v-if="new_law == 'yes'">
            <b-form @submit.stop.prevent="uploadFile">
                <b-form-group id="datafile-group" label="File" class="half-width mr1" label-for="datafile">
                    <b-form-file id="datafile" name="datafile" accept=".xlsx,.xls" v-on:change="handleFileUpload()"
                        aria-describedby="datafile-feedback" data-vv-as="File"></b-form-file>
                    <b-form-invalid-feedback id="datafile-feedback">{{ veeErrors.first('datafile')
                        }}</b-form-invalid-feedback>
                </b-form-group>
                <b-form-group id="file-date-group" label="Date [YYYY-MM-DD] *" class="half-width"
                    label-for="day_one_text">
                    <b-input-group class="my-0">
                        <b-form-input id="file_date_text" v-model="file_date_text" name="file_date_text"
                            v-validate="{ required: true }" type="text" placeholder="YYYY-MM-DD" autocomplete="off"
                            :state="validateState('file_date_text')" aria-describedby="file_date_text-feedback"
                            data-vv-as="From Date"></b-form-input>
                        <b-input-group-append>
                            <b-form-datepicker id="file_date" v-model="file_date_text" @context="onContext"
                                aria-controls="file_date_text" button-only right locale="en-US"></b-form-datepicker>
                        </b-input-group-append>
                        <b-form-invalid-feedback id="file_date_text-feedback">{{ veeErrors.first('file_date_text')
                            }}</b-form-invalid-feedback>
                    </b-input-group>
                </b-form-group>
                <div class="full-width text-center mt-3">
                    <b-button type="submit" variant="primary">Submit</b-button>
                </div>
            </b-form>
        </b-modal>

        <b-modal id="satement-tax-deduction-upload-excell-old" size="lg" centered hide-footer
            title="Upload Receipt File" v-else>
            <b-form @submit.stop.prevent="uploadFile">
                <b-form-group id="datafile-group" label="File" class="half-width mr1" label-for="datafile">
                    <b-form-file id="datafile" name="datafile" accept=".xlsx,.xls" v-on:change="handleFileUpload()"
                        aria-describedby="datafile-feedback" data-vv-as="File"></b-form-file>
                    <b-form-invalid-feedback id="datafile-feedback">{{ veeErrors.first('datafile')
                        }}</b-form-invalid-feedback>
                </b-form-group>
                <b-form-group id="file-date-group" label="Date [YYYY-MM-DD] *" class="half-width"
                    label-for="day_one_text">
                    <b-input-group class="my-0">
                        <b-form-input id="file_date_text" v-model="file_date_text" name="file_date_text"
                            v-validate="{ required: true }" type="text" placeholder="YYYY-MM-DD" autocomplete="off"
                            :state="validateState('file_date_text')" aria-describedby="file_date_text-feedback"
                            data-vv-as="From Date"></b-form-input>
                        <b-input-group-append>
                            <b-form-datepicker id="file_date" v-model="file_date_text" @context="onContext"
                                aria-controls="file_date_text" button-only right locale="en-US"></b-form-datepicker>
                        </b-input-group-append>
                        <b-form-invalid-feedback id="file_date_text-feedback">{{ veeErrors.first('file_date_text')
                            }}</b-form-invalid-feedback>
                    </b-input-group>
                </b-form-group>
                <div class="full-width text-center mt-3">
                    <b-button type="submit" variant="primary">Submit</b-button>
                </div>
            </b-form>
        </b-modal>

    </div>
</template>
<script>


export default {

    mounted() {
        this.$refs.trzcalendar;
        // this.getAcl();
    },
    props: ['flag', 'new_law'],
    components: {

    },
    data() {

        return {

            cu: window.location.href,
            ce: false,


            showoverlay: true,

            fiscal_years: [
                { value: "2019-2020", text: "2019-2020" },
                { value: "2020-2021", text: "2020-2021" },
                { value: "2021-2022", text: "2021-2022" },
            ],

            fiscal_year: "",
            month: '',
            excelfile: null,
            file_date_text: '',
            compliance_placeholder: 'N/A',
            d_month: '',
            d_year: '',

            months: [
                { value: "1", text: "January" },
                { value: "2", text: "February" },
                { value: "3", text: "March" },
                { value: "4", text: "April" },
                { value: "5", text: "May" },
                { value: "6", text: "June" },
                { value: "7", text: "July" },
                { value: "8", text: "August" },
                { value: "9", text: "September" },
                { value: "10", text: "October" },
                { value: "11", text: "November" },
                { value: "12", text: "December" },
            ],


            deductdata: [],

            search: '',
            length: 20,
            length_options: [],
            pagination: { currentPage: 1, total: '', nextPage: '', prevPage: '', from: '', to: '', pages: 1 },


            empty_result: 'Fetching data..',

            received_report_info: [],
            loader: false,
            /***Ali */

            column_selected: [],
            column_options: [],
            default_fields: [],
            column_selected_view: [],
            show_selected: '',

        }
    },
    methods: {

        replaceTableHeads(val) {
            val = val.replace(/_/g, ' ');

            val = val.toLowerCase().split(' ');
            for (var i = 0; i < val.length; i++) {
                if (val[i].length == 2 && val[i] == 'pf') {
                    val[i] = val[i].toUpperCase();
                } else {
                    val[i] = val[i].charAt(0).toUpperCase() + val[i].substring(1);
                }
            }
            return val.join(' ');
        },
        sortArrays(arrays) {
            return _.orderBy(arrays, 'ordering', 'desc');
        },
        year_from_fiscal_year_month_val(month_val, fiscal_year) {
            console.log(fiscal_year);
            var year_array = [];
            year_array = fiscal_year.split('-');
            console.log(year_array);
            if (month_val > 6 && month_val <= 12) {
                return year_array[0];
            } else {
                return year_array[1];
            }

        },
        validateState(ref) {
            if (
                this.veeFields[ref] &&
                (this.veeFields[ref].dirty || this.veeFields[ref].validated)
            ) {
                return !this.veeErrors.has(ref);
            }
            return null;
        },

        statementOfDeductData: function (month, fiscal_year) {
            if (!this.checkNet()) return false;

            if (this.column_selected.indexOf('name') === -1) {
                this.column_selected.unshift('name');
            }

            let year = this.fiscal_year;
            //let year = this.year_from_fiscal_year_month_val(month,fiscal_year);
            this.d_month = this.months[month - 1].text;
            this.d_year = year;
            this.empty_result = 'Fetching data..';

            this.deductdata = [];

            let currentObj = this;

            let url = this.$api_url + '/statement-of-deduct-data-custom';
            let formData = new FormData();
            formData.append('year', year);
            formData.append('month', month);
            formData.append('column_selected', this.column_selected);
            axios.post(url, formData).then(function (response) {
                this.deductdata = response.data;

                if (this.deductdata.length == 0)
                    this.empty_result = 'No Result Found!';

            }.bind(this)).catch(function (error) { currentObj.serverError(error); });



            this.$bvModal.show('satement-tax-deduction');

        },
        showUpload: function (month) {
            if (!this.checkNet()) return false;

            this.details = [];
            let year = this.fiscal_year;
            this.month = month;

            this.showoverlay = true;

            let url = this.$api_url;

            if (this.new_law == 'yes') {
                this.$bvModal.show('satement-tax-deduction-upload-excell');
            } else {
                this.$bvModal.show('satement-tax-deduction-upload-excell-old');
            }
        },
        handleFileUpload() {
            this.excelfile = event.target.files[0];
        },
        onContext(ctx) {
            this.file_date_text = ctx.selectedYMD;
        },
        uploadFile: function (event) {
            if (!this.checkNet()) return false;
            this.$validator.validateAll().then(result => {
                if (!result) {

                    this.$bvToast.toast("Please fill all required fields [marked red]", {
                        title: `Error`,
                        variant: 'danger',
                        solid: true
                    });

                    return;
                }
                this.showoverlay = true;


                const config = {
                    headers: { 'content-type': 'multipart/form-data' }
                }
                const data = new FormData();
                data.append('image', this.excelfile);
                data.append('year', this.fiscal_year);
                data.append('month', this.month);
                data.append('file_date_text', this.file_date_text);

                axios.post(this.$api_url + '/payroll_report_return_statement_of_deduct?upload_received_copy=upload&dataflg=1', data, config).
                    then(function (response) {


                        this.$bvToast.toast('Uploaded successfully.', {
                            title: `Success`,
                            variant: 'info',
                            solid: true
                        });


                        if (this.new_law == 'yes') {
                            this.$bvModal.hide('satement-tax-deduction-upload-excell');
                        } else {
                            this.$bvModal.hide('satement-tax-deduction-upload-excell-old');
                        }
                        this.getReceivedFile();
                    }.bind(this)).
                    catch(function (error) {
                        //alert(error.response.data.errors);
                    });

            });
        },
        getReceivedFile: function () {
            if (!this.checkNet()) return false;
            axios.get(this.$api_url + '/return/get_payroll_report_return108_received_copy', {
                params: {

                }
            }).then(function (response) {
                this.received_report_info = response.data;

                if (this.received_report_info.length > 0) {
                    this.fiscal_year = this.received_report_info[0].fiscal_year;
                }

            }.bind(this));
        },

        getReportNewFormate: function (year, month, format) {

            if (!this.checkNet()) return false;
            if (this.column_selected.indexOf('jobposition') === -1) {
                this.column_selected.unshift('jobposition');
            }
            if (this.column_selected.indexOf('name') === -1) {
                this.column_selected.unshift('name');
            }
            this.loader = true;
            let formData = new FormData();
            formData.append('year', year);
            formData.append('month', month);
            formData.append('format', format);
            formData.append('grid_report', 'Excel');
            formData.append('report', 1);
            formData.append('column_selected', this.column_selected);
            const config = {
                headers: { 'Content-Type': 'application/json; charset=utf-8', },
                responseType: 'blob',
            }
            let url = this.$api_url;

            url = url + '/payroll_report_return_statement_of_deduct_custom_new';

            axios.post(url, formData, config).then(function (response) {
                //this.payroll_reporting_data = response.data;
                //console.log(response.data);
                //var fileURL = this.$api_url+'/payroll_head_basis_yearly_report?grid_report=Excel&year='+fiscal_year;
                // var fileURL = response.data;
                // this.download_file(fileURL);
                this.loader = false;
                if (response.data.type == 'application/json') {
                    let file = new Blob([response.data], { type: 'application/json' });
                    const cast = Promise.resolve(file.text());
                    cast.then((value) => {
                        let err_obj = JSON.parse(`${value}`);
                        this.$bvToast.toast(err_obj.error_msg, { title: 'Error', variant: 'danger', solid: true });
                    });
                } else {
                    this.global_download_file_content(response);
                }

            }.bind(this))
                .catch(error => {
                    if (error.response) {
                        this.loader = false;
                    }
                });
            return false;

        },

        getReport: function (year, month) {

            if (!this.checkNet()) return false;
            if (this.column_selected.indexOf('name') === -1) {
                this.column_selected.unshift('name');
            }
            this.loader = true;
            let formData = new FormData();
            formData.append('year', year);
            formData.append('month', month);
            formData.append('grid_report', 'Excel');
            formData.append('report', 1);
            formData.append('column_selected', this.column_selected);
            const config = {
                headers: { 'Content-Type': 'application/json; charset=utf-8', },
                responseType: 'blob',
            }
            let url = this.$api_url;

            url = url + '/payroll_report_return_statement_of_deduct_custom';

            axios.post(url, formData, config).then(function (response) {
                //this.payroll_reporting_data = response.data;
                //console.log(response.data);
                //var fileURL = this.$api_url+'/payroll_head_basis_yearly_report?grid_report=Excel&year='+fiscal_year;
                // var fileURL = response.data;
                // this.download_file(fileURL);
                this.loader = false;
                if (response.data.type == 'application/json') {
                    let file = new Blob([response.data], { type: 'application/json' });
                    const cast = Promise.resolve(file.text());
                    cast.then((value) => {
                        let err_obj = JSON.parse(`${value}`);
                        this.$bvToast.toast(err_obj.error_msg, { title: 'Error', variant: 'danger', solid: true });
                    });
                } else {
                    this.global_download_file_content(response);
                }

            }.bind(this))
                .catch(error => {
                    if (error.response) {
                        this.loader = false;
                    }
                });
            return false;

        },

        download_file(fileURL) {
            if (!this.checkNet()) return false;

            var fileName = fileURL.substring(fileURL.lastIndexOf('/') + 1);
            if (!window.ActiveXObject) {
                var save = document.createElement('a');
                save.href = fileURL;
                save.target = '_blank';
                //var filename = fileURL.substring(fileURL.lastIndexOf('/')+1);
                save.download = fileName || filename;
                if (navigator.userAgent.toLowerCase().match(/(ipad|iphone|safari)/) && navigator.userAgent.search("Chrome") < 0) {
                    document.location = save.href;
                } else {
                    var evt = new MouseEvent('click', {
                        'view': window,
                        'bubbles': true,
                        'cancelable': false
                    });
                    save.dispatchEvent(evt);
                    (window.URL || window.webkitURL).revokeObjectURL(save.href);
                }
            }
            else if (!!window.ActiveXObject && document.execCommand) {
                var _window = window.open(fileURL, '_blank');
                _window.document.close();
                _window.document.execCommand('SaveAs', true, fileName || fileURL)
                _window.close();
            }
        },
        getPayrollDefaultField() {
            if (!this.checkNet()) return false;
            axios.get(this.$api_url + '/report/payrollreporting/defaultfields', {
            }).then(function (response) {
                this.default_fields = response.data;
                let co = [];
                let available_colunms = [];
                this.default_fields.forEach(element => {

                    co = co.concat([{ text: this.stringView(element), value: element }]);
                    available_colunms = available_colunms.concat(element);
                });

                this.column_options = this.column_options.concat(co);
                this.column_selected.forEach(element => {
                    if (available_colunms.includes(element)) {
                        //
                    }
                    else {
                        this.column_selected.splice(this.column_selected.lastIndexOf(element), 1);
                    }
                });

            }.bind(this));
        },
        stringView(str) {
            if (str == 'jobposition')
                str = 'job_position';
            var i, frags = str.split('_');
            for (i = 0; i < frags.length; i++) {
                frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
            }
            return frags.join(' ');
        },
        stringViewReverse(str) {
            if (str == 'jobposition')
                str = 'job_position';

            str = str.replace(/ /g, "_").toLowerCase();

            return str;
        },
        setcolumn: function () {
            this.$cookies.set("report_column_selected", this.column_selected);
            this.$refs.dropdown.hide(true);
            this.$refs.dropdown1.hide(true);
        },
        capitalizeTheFirstLetterOfEachWord(words) {
            var separateWord = words.toLowerCase().split(' ');
            for (var i = 0; i < separateWord.length; i++) {
                separateWord[i] = separateWord[i].charAt(0).toUpperCase() +
                    separateWord[i].substring(1);
            }
            return separateWord.join(' ');
        },



    },
    created: function () {
        // if(this.$cookies.isKey("report_column_selected"))
        // {
        //     if(this.$cookies.get("column_selected") != null && this.$cookies.get("column_selected") != '')
        //         this.column_selected = this.$cookies.get("report_column_selected").split(',');
        // }


        // Start: Mustafijur : 8-24-25 Cookie
        if (this.$cookies.isKey("report_column_selected")) {
            if (this.$cookies.get("report_column_selected") != null && this.$cookies.get("report_column_selected") != '') {
                if (Array.isArray(this.$cookies.get("report_column_selected"))) {
                    this.column_selected = this.$cookies.get("report_column_selected");
                }
                else {
                    this.column_selected = this.$cookies.get("report_column_selected").split(',');
                }
            }
        }
        // End: Mustafijur : 8-24-25 Cookie

        this.getPayrollDefaultField();

        //this.statementOfDeductData('2020-2021');
        //Fire.$on('reloadUsers', () => {this.statementOfDeductData()});
        this.getReceivedFile();
        // this.fiscal_year = this.getCurrentFinancialYear();
    },
    computed:
    {
        filteredData() {
            let filtered_list = this.deductdata;
            if (this.search) {
                filtered_list = filtered_list.filter((row) => { return Object.keys(row).some((key) => { return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1; }) });
            }
            return filtered_list;
        },
        paginatedData() {
            return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
        },
        clickSelect() {

            this.column_selected_view = this.column_selected;
            if (this.column_selected_view.length != this.column_selected_view.length) {
                this.column_selected_view = this.column_selected;
            }
            if (this.column_selected.indexOf('name') > -1) {
                this.column_selected.splice('name', 1);
            }
            this.show_selected = this.column_selected_view.join();
            this.show_selected = this.show_selected.replaceAll("_", " ");
            this.show_selected = this.show_selected.replaceAll(",", " , ");
            this.show_selected = this.capitalizeTheFirstLetterOfEachWord(this.show_selected);

            if (this.column_selected.length == 0) {
                this.show_selected = 'None Selected';
            }

            this.$cookies.set("report_column_selected", this.column_selected);

        },

    }
}
</script>
<style>
.d-inline-block.trz_fields.trz-custom-dropdown.mb-1 button {
    position: relative !important;
    bottom: 0 !important;
}
</style>
